

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from '../models/create-result';
import { ParticipantViewModel } from '../models/participant-view-model';
import { ParticipantService } from '../services/participant.service';
import { UserDataStoreService } from '../services/user-data-store.service';
import { PermissionEnum } from '../services/guards/permissions';
import { VASService } from '../services/vas.service';
import { VasConfigurationViewModel } from '../models/vas-configuration-view-model';
import { MerchantService } from '../services/merchant.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MerchantDetailModel } from '../models/merchant-detail-model';
import { CardAcceptorConfigService } from '../services/card-acceptor-config.service';
import { TmCardAcceptorConfigViewModel } from '../models/tm-card-acceptor-model';
import { CardAcceptorConfigViewModel } from '../models/card-acceptor-config-view-model';
import { TerminalService } from '../services/terminal.service';
import { SinkNodeMappedFieldsViewModel } from '../models/sinknode-mapped-fields-view-model';
import { TaCardAcceptorConfigViewModel } from '../models/ta-card-acceptor-model';
import { PFIViewModel } from '../models/PFI-view-model';
import { promise } from 'protractor';


@Component({
  selector: 'merchant-migration-mapping-view',
  templateUrl: './merchant-migration-view.component.html',
  styleUrls: ['./merchant-migration-view.component.scss']
})
export class MerchantMigrationViewComponent {

  //Select2OptionData
  public merchantNumbers: Select2OptionData[];
  public mapServiceTypes: Select2OptionData[];
  public providers: Select2OptionData[];
  public mapProviders: Select2OptionData[];
  public cardAcceptorConfigs: Select2OptionData[];

  //Interfaces
  public participant: ParticipantViewModel;
  public createResult: CreateResult;
  public merchantDetails: MerchantDetailModel;
  public participantDetails: ParticipantViewModel;
  public tmCardAcceptor: TmCardAcceptorConfigViewModel;
  public taCardAcceptor: TaCardAcceptorConfigViewModel;
  public cardAcceptorConfig: CardAcceptorConfigViewModel;
  public cardAcceptorConfigss: CardAcceptorConfigViewModel[];
  public sinkNodesMappedFields: SinkNodeMappedFieldsViewModel[];
  public pfi: PFIViewModel;

  //Boolen
  public canEdit: boolean;
  public dataUnavailable: boolean;
  error: boolean;
  public IsGovernmentalMerchant: boolean;
  public displayIsoAndAggContent: boolean;
  public displayIsoContent = false;
  public save: boolean;

  //string and numbers
  errorMessage: string;
  public MerchantNumber: number;
  public merchantNumberId: string;
  public CardAcceptorConfigId: number;
  public participantID: number;
  public postalServiceCode: string;
  public subMerchantId: string;
  public paymentFacilitatorId: string;
  public paymentFacilitatorIdVisa: string;
  public independentSalesOrganizationId: string;
  public independentSalesOrganizationIdVisa: string;
  public customerServicePhoneNo: string;
  public merchantStreetAddress: string;
  public disabledOption: string;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  constructor(
    private _participantService: ParticipantService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _route: ActivatedRoute,
    private _vasService: VASService,
    private _merchantService: MerchantService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _terminalService: TerminalService) {
    this._route.params.subscribe(async params => {
      this.save = false;
      this.participantID = Number(params.id);
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);

      this._ngxUiLoaderService.start();

      await this.initParticipant(params.id);

      this.merchantNumbers = (await this._merchantService.GetAllMerchantsByParticipantID(this.participantID)).map((x) => {
        return { id: x.merchantNumber.toString(), text: x.merchantNumber.toString() + " - " + x.nameLocation.toString() }
      });

      this.cardAcceptorConfigs = (await this._cardAcceptorConfigService.GetAllConfigs()).map((x) => {
        return { id: x.id.toString(), text: x.name }
      });

      if (this.cardAcceptorConfigs.length == 0) {
        this.error = true;
        this.errorMessage = "Card acceptor config must be set first.";
        this.disabledOption = "disabled";
      }
      else {
        this.error = false;
        this.errorMessage = "";
        this.disabledOption = "";
      }


      this._ngxUiLoaderService.stop();
    });
  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public async SaveData(): Promise<void> {
    this._ngxUiLoaderService.start();
    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {

      var merchantDetail: MerchantDetailModel = {
        cardAcceptorConfigId: this.CardAcceptorConfigId,
        configId: (this.taCardAcceptor != null && this.taCardAcceptor != undefined ? 1 : 2),
        subMerchantId: this.subMerchantId,
        paymentFacilitatorId: this.paymentFacilitatorId,
        paymentFacilitatorIdVisa: this.paymentFacilitatorIdVisa,
        independentSalesOrgId: this.independentSalesOrganizationId,
        independentSalesOrgIdVisa: this.independentSalesOrganizationIdVisa,
        customerServicePhoneNo: this.customerServicePhoneNo,
        merchantStreetAddress: this.merchantStreetAddress,
        merchantNumber: this.merchantNumberId,
        postalServiceCode: this.postalServiceCode,
        town: '',
        participantId: this.participantID,
        isGovernmentalMerchant: false,
        merchantVerificationValue: ''
      };

      this.createResult = await this._merchantService.AddMerchantDetails(merchantDetail);

      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");
        this.error = false;
      }
      else {
        this._toastService.error(this.createResult.message, "Error");
        this.error = true;
        this.errorMessage = this.createResult.message;
      }
    }
    this._ngxUiLoaderService.stop();
  }

  public async RetrieveData(): Promise<void> {
    this._ngxUiLoaderService.start();
    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {

      this.merchantDetails = await this._merchantService.GetMerchantDetails(this.MerchantNumber.toString());

      if (!!this.merchantDetails) {
        this._toastService.success("No action required, data exit for this merchant", 'Success');
        this.dataUnavailable = false;
        this.save = false;
      }
      else {
        this.save = true;
        this.dataUnavailable = true;
        this.participantDetails = await this._participantService.GetAggregateMerchant(this.participantID);
        this.tmCardAcceptor = await this._merchantService.GetTmCardAcceptor(this.MerchantNumber.toString());
        this.taCardAcceptor = await this._merchantService.GetTaCardAcceptor(this.MerchantNumber.toString());

        if (!!this.participantDetails.isAggregator) {
          this.displayIsoAndAggContent = this.participantDetails.isAggregator;
          this.pfi = await this._merchantService.GetPFI(this.MerchantNumber.toString(), this.participantDetails.aggregatorSinkNode, this.participantDetails.aggregatorMerchant);
          if (!!this.pfi) {
            this.subMerchantId = this.pfi.subMerchantId;
            this.paymentFacilitatorId = this.pfi.paymentFacilitatorId;
            this.paymentFacilitatorIdVisa = this.pfi.paymentFacilitatorIdVisa;
            this.independentSalesOrganizationId = this.pfi.independentSalesOrgId;
            this.independentSalesOrganizationIdVisa = this.pfi.independentSalesOrgIdVisa;
            this.customerServicePhoneNo = this.pfi.customerServicePhoneNo;
            this.merchantStreetAddress = this.pfi.merchantStreetAddress;
          }
        }

        this.merchantNumberId = this.MerchantNumber.toString();
        this.postalServiceCode = "0000";
        this.cardAcceptorConfigss = await (await this._cardAcceptorConfigService.GetAllConfigs()).filter(x => x.routingGroup == this.tmCardAcceptor.routing_group);
        if (!!this.cardAcceptorConfigss) {
          this.CardAcceptorConfigId = this.cardAcceptorConfigss[0].id;
        }
      }
    }

    this._ngxUiLoaderService.stop();
  }

  public omit_special_char(event) {

    if (!!event) {
      var k;
      k = event.charCode;//         k = event.keyCode;  (Both can be used)

      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 42 || k == 44);
    }
  }

}

